<template>
  <div id="isRead">
    <div @click="change">
      <span class="mWord" :class="todoActive">{{ todoWord[0] }}</span>
      <span class="mWord" :class="doneActive">{{ todoWord[1] }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "IsRead",
  // data() {
  //   return {
  //     todo: true
  //   }
  // },
  props: {
    todoWord: {
      type: Array,
      // 必须返回一个对象
      default: () => ["未看", "已看"],
    },
    todo: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    todoActive() {
      return this.todo ? "todoActive" : "";
    },
    doneActive() {
      return !this.todo ? "doneActive" : "";
    },
  },
  methods: {
    change() {
      this.$emit("reClick");
    },
  },
};
</script>

<style scoped lang="less">
.mWord {
  margin-right: 0.125rem;
  font-size: 0.2rem;
  font-weight: 600;
  user-select: none;
}
.todoActive {
  color: @main-col;
  border-bottom: 0.03125rem solid @main-col;
}
.doneActive {
  color: @Affiliate-col;
  border-bottom: 0.03125rem solid @Affiliate-col;
}
</style>